import moment from 'moment'

export const newEntry = () => ({
  input: '',
  result: {},
  timestamp: moment(),
})
